import { ButtonDeprecated } from "@volt_developers/components/components/ButtonDeprecated";
import { useTranslation } from "react-i18next";

import { TransactionSigningConfirmModal } from "modules/auth/components/TransactionSigningConfirmModal";

import { TEST_IDS } from "../../../constants/TestIds";
import { TRANSLATION_KEYS } from "../../../constants/TranslationKeys";
import { DisabledApproveButton } from "./DisabledApproveButton";
import { useApproveButton } from "./useApproveButton";

export function ApproveButton() {
  const { t } = useTranslation("refunds");

  const {
    id,
    isModalActive,
    toggleIsModalActive,
    handleButtonClick,
    isVisible,
    isDisabled,
    tooltipTitleTranslationKey,
    isLoading,
    handleApproveRefund,
  } = useApproveButton();

  if (!isVisible || !id) {
    return null;
  }

  if (isDisabled && tooltipTitleTranslationKey) {
    return (
      <DisabledApproveButton tooltipTitle={t(tooltipTitleTranslationKey)} />
    );
  }

  return (
    <>
      <TransactionSigningConfirmModal
        isOpen={isModalActive}
        title={t(TRANSLATION_KEYS.approvingRefunds)}
        transactionId={id}
        onClose={toggleIsModalActive}
        onSubmit={handleApproveRefund}
      />
      <ButtonDeprecated
        data-testid={TEST_IDS.refundApproveButton}
        disabled={isDisabled}
        loading={isLoading}
        onClick={handleButtonClick}
      >
        {t(TRANSLATION_KEYS.approve)}
      </ButtonDeprecated>
    </>
  );
}
